import lozad from 'lozad'
import snackbar from 'node-snackbar'
import './modules/packages-fetch.js'

// import '../../helpers/styles/_base.scss'

import '../../components/header/header.component'
import '../../components/footer/footer.component'

import { appInitScroll } from './modules/scroll'
import { partnersPopupListener } from './modules/partners-popup'
import { propertyPopupListener } from './modules/property-popup'

export class Application {
  static isRunning = false;

  static run() {
    try {
      const buildInfo = `APPLICATION BUILT INFO\nEnvironment: [${__APP_BUILD_ENVIRONMENT__}]\nVersion: ${__APP_BUILD_VERSION__}`;

      console.info('%c%s', 'background-color: yellow', buildInfo);
    } catch (e) {
      console.error(e);
    }

    // ---

    Application.lozad()
    appInitScroll()
    partnersPopupListener()
    propertyPopupListener()

    this.isRunning = true;
  }

  static lozad(selector = '.lozad') {
    lozad(selector, {
      loaded: function(el) {
        el.onload = () => {
          el.classList.add('loaded')
        }
      }
    }).observe()
  }

  static get BRAIN_TREE_TOKEN() {
    try {
      return document.querySelector('meta[name="braintree-token"]').content
    } catch (e) {
      console.error(
        'meta[name="braintree-token" content="BRAIN_TREE_TOKEN"] element undefined'
      )
    }
  }
  static get BACKEND_MODE() {
    try {
      return document.querySelector('meta[name="app-env"]').content
    } catch (e) {
      console.warn('meta[name="APP-ENV" content="APP-ENV"] element undefined')
      return 'development'
    }
  }
  static get GOOGLE_MERCHANT_ID() {
    try {
      return document.querySelector('meta[name="google-merchant-id"]').content
    } catch (e) {
      console.error(
        'meta[name="google-merchant-id" content="APP-ENV"] element undefined'
      )
    }
  }
  static get CSRF() {
    try {
      return document.querySelector('meta[name="csrf-token"]').content
    } catch (e) {
      console.error(
        'meta[name="csrf-token" content="CSRF_TOKEN"] element undefined'
      )
    }
  }
  static get GOOGLE_API_KEY() {
    try {
      return document.querySelector('meta[name="google-map-api-key"]').content
    } catch (e) {
      console.error(
        'meta[name="google-map-api-key" content="GOOGLE_MAP_API_KEY"] element undefined'
      )
    }
  }
  static message(message, options) {
    snackbar.show({
      showAction: false,
      text: message,
      backgroundColor: '',
      pos: 'bottom-center',
      ...options
    })
  }
  static error(message, options) {
    snackbar.show({
      showAction: false,
      text: message,
      backgroundColor: '#d1273a',
      pos: 'bottom-center',
      ...options
    })
  }
  static swiper = () => {
    return import(/* webpackChunkName: "swiper" */ 'swiper').then(
      ({ Swiper, Navigation }) => {
        return { Swiper, Navigation }
      }
    )
  }
  static generateLoader() {
    return `
    <div class="component-loader">
      <div class="lds-grid">
        ${new Array(9).fill('<div></div>').join('')}
      </div>
    </div>
    `
  }
}
